<template>
  <div class="home h-100 w-100vw p-relative" :class="'swipe-'+homeSwiperIndex">
    <HomeSwiper :rotationLv="rotationLv" />
    <div v-if="isMobile().any" class="artwork-slider-wrapper" :class="mobileRangeClass">
      <b-form-input v-model="rotationLv" :class="isMobile().any? 'mobile': ''" type="range" min="1" max="8"></b-form-input>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HomeSwiper from '@/components/HomeSwiper.vue'
import isMobile from 'ismobilejs'

export default {
  name: 'Home',
  components: {
    HomeSwiper
  },
  data() {
    return {
      isMobile,
      rotationLv: '3'
    }
  },
  mounted () {
    // exhibitionsのページ数を取りに行く
    this.getExhibitionPages();
  },
  computed: {
    ...mapState({
      homeSwiperIndex: state => state.homeSwiperIndex,
    }),
    mobileRangeClass() {
      if (this.$route.path == '/' && this.homeSwiperIndex == 2) {
        return ''
      } else {
        return 'clear'
      }
    }
  },
  methods: {
    ...mapActions({
      setExhibitionMaxPages: 'doSetExhibitionMaxPages'
    }),

    async getExhibitionPages() {
      // スマホの場合は1回で2件表示
      let perPage = 4
      if (this.isMobile().phone) perPage = 2
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/exhibition?per_page='+ perPage )
      .catch((e) => {
        console.log(e)
        // this.exhibitions = []
      });
      if (payload.data) {
        this.setExhibitionMaxPages(parseInt(payload.headers['x-wp-totalpages']))
        // console.log(payload)
        // this.totalPosts = payload.headers['x-wp-total']
        // this.totalPages = payload.headers['x-wp-totalpages']
        // this.exhibitions = payload.data
        // this.setPageControl({lightTheme: false, left: false, right: false, up: true, down: this.totalPages > this.pageNo})

      } else {
        // this.exhibitions = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.artwork-slider-wrapper {
  position: fixed;
  z-index: 3;
  bottom: 70px;
  left: 80px;
  width: calc(100vw - 160px);
  @media screen and (min-width: 576px){
    bottom: 70px;
    left: 180px;
    width: calc(100vw - 360px);    
  }
  @media screen and (min-width: 768px){
    left: 280px;
    width: calc(100vw - 560px);    
  }
  opacity: 1;
  transition: opacity 0.3s;
  &.clear {
    opacity: 0;
  }
}
</style>